module.exports = __webpack_public_path__ + "static/wiczlino5-4a03c89430c7c6bf196a93ebd792a2a4.jpg";